import(/* webpackMode: "eager" */ "/var/www/vhosts/arsenioevoo.com/httpdocs/frontend/src/app/[lang]/not-found.js");
